/**
 * Parse EUA price string from API (exact decimal from Postgres numeric(10,3))
 * to number for display and arithmetic. Use at the display/calculation boundary.
 */
export function parseEuaPrice(value: string | null | undefined): number {
  if (value == null || value === '') {
    return 0
  }
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}
